import React from 'react';
import {
  Button,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  SvgIcon,
} from '@material-ui/core';

import start from 'assets/images/bg/bg_header.png';
import start1 from 'assets/images/home/topbg1.png';
import startMb from 'assets/images/bg/bg_header_mb.png';
import startMb2 from 'assets/images/bg/bg_header_mb2.png';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ReactComponent as btcIcon} from 'assets/images/svg/btc-icon.svg';
import {ReactComponent as etcIcon} from 'assets/images/svg/etc-icon.svg';
import {ReactComponent as xrpIcon} from 'assets/images/svg/xrp-icon.svg';
import {useFetch} from 'api/api';
import {Text} from 'App';
import {link_apple_download, link_google_download} from 'common/constants';
import {Stack} from '@mui/material';
import {AppStoreButton} from '../DownApp2/AppStoreButton';
import {CHPlayButton} from '../DownApp2/CHPlayButton';

export default function HimegamiStart() {
  const classes = useStyles();
  const {t, i18n} = useTranslation();
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const {data: dataFetch, loading: Loading} = useFetch([
    'get',
    'tokens/default?symbols=BTC,ETC,XRP',
  ]);
  const dataToken = [
    {
      name: 'Bitcoin',
      symbol: 'BTC',
      image: btcIcon,
      viewBox: '0 0 26 26',
      price: dataFetch?.data[0]?.last_price || 0,
    },
    {
      name: 'Ripple Coin',
      symbol: 'XRP',
      image: xrpIcon,
      viewBox: '0 0 26 26',
      price: dataFetch?.data[2]?.last_price || 0,
    },
    {
      name: 'Ethereum Classic',
      symbol: 'ETC',
      image: etcIcon,
      viewBox: '0 0 26 26',
      price: dataFetch?.data[1]?.last_price || 0,
    },
  ];

  return (
    <div className={classes.root}>
      <Grid container justifyContent="space-between">
        <Grid item md={6} sm={12} xs={12} className={classes.headerTitle}>
          <div className={classes.overlay}>
            <Typography
              className={classes.title}
              style={{fontSize: matches && i18n.language == 'ja-JP' ? 22 : 25}}>
              {t('homepage.introduce.title')}
            </Typography>
            <Typography variant="h5" className={classes.contentShinobi}>
              {t('homepage.introduce.description')}
            </Typography>
          </div>
          <Stack
            direction={{md: 'row', sm: 'column', xs: 'column'}}
            alignItems="center"
            justifyContent={{xs: 'center', md: 'flex-start'}}
            spacing={1.5}>
            <AppStoreButton />
            <CHPlayButton />
          </Stack>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          container
          justifyContent="flex-end"
          className={classes.imageWallet}>
          {dataToken?.map((item) => (
            <Grid container justifyContent="center" key={item.name}>
              <Grid
                item
                xs={3}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <SvgIcon component={item?.image} viewBox={item?.viewBox} />
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}>
                <div>
                  <Text variant="namecoin">{item?.name}</Text>
                  <Text variant="symbolcoin">{item?.symbol}</Text>
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}>
                <Text variant="namecoin" style={{fontWeight: 600}}>
                  {'$' + item?.price}
                </Text>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    background: `url(${start})`,
    height: '45vw',
    padding: '13% 5% 10% 10%',
    [theme.breakpoints.down('md')]: {
      height: '50vw',
      padding: '15% 5% 10% 10%',
    },
    [theme.breakpoints.down('sm')]: {
      height: '168vw',
      background: `url(${startMb2})`,
      padding: '18% 15% 10% 15%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      position: 'relative',
      marginBottom: theme.spacing(10),
    },
    [theme.breakpoints.down('xs')]: {
      background: `url(${startMb})`,
      position: 'relative',
      height: '200vw',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      padding: '100px 32px 5px 32px',
      marginBottom: theme.spacing(10),
    },
  },
  title: {
    fontSize: 60,
    fontWeight: 700,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3vw',
      lineHeight: '50px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 30,
      lineHeight: '36px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      lineHeight: '30px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 25,
      textAlign: 'center',
      lineHeight: '28px',
    },
  },
  overlay: {
    width: '100%',
    textAlign: 'left',
    color: '#fff',
    fontWeight: 700,
    marginBottom: 32,

    [theme.breakpoints.down('sm')]: {
      marginBottom: 50,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 32,
    },
  },

  whitePaper: {
    display: 'flex',
    marginTop: 64,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      marginTop: 10,
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      marginTop: 32,
      display: 'block',
    },
  },
  imageWallet: {
    background: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(10px)',
    borderRadius: 10,
    height: 220,
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      bottom: '27%',
      right: 16,
      height: 180,
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      bottom: '18%',
      right: 16,
      height: 120,
    },
  },
  headerTitle: {
    paddingLeft: 50,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  contentShinobi: {
    marginTop: 16,
    fontSize: 22,
    [theme.breakpoints.down('lg')]: {
      fontSize: 21,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
      textAlign: 'center',
    },
  },
  imageButton: {
    [theme.breakpoints.down('md')]: {
      width: 150,
    },
    [theme.breakpoints.down('sm')]: {
      width: 150,
    },

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 17,
    },
  },
}));
